import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card'

interface Recommendation {
  focus: string
  action: string
  linkedInsight?: string
  priority: 'High' | 'Medium' | 'Low'
}

interface RecommendationsSectionProps {
  recommendations: Recommendation[]
}

export function RecommendationsSection({ recommendations }: RecommendationsSectionProps) {
  if (!recommendations?.length) return null

  const getPriorityColor = (priority: string) => {
    switch (priority.toLowerCase()) {
      case 'high':
        return 'text-red-600 dark:text-red-400'
      case 'medium':
        return 'text-yellow-600 dark:text-yellow-400'
      case 'low':
        return 'text-green-600 dark:text-green-400'
      default:
        return 'text-muted-foreground'
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Strategic Recommendations</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {recommendations.map((recommendation, index) => (
            <Card key={index} className="h-full">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="text-base">{recommendation.focus}</CardTitle>
                  <span className={`text-sm font-medium ${getPriorityColor(recommendation.priority)}`}>
                    {recommendation.priority} Priority
                  </span>
                </div>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-sm text-muted-foreground">{recommendation.action}</p>
                {recommendation.linkedInsight && (
                  <p className="text-sm text-muted-foreground italic">
                    Based on: {recommendation.linkedInsight}
                  </p>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}